import { _pHttp } from "../_pHttp";

interface OrganizationBody {
  title: string;
  operatorId: string[];
  saleLimit: number;
  match: number;
  useTicketLimit: number;
}

export async function addOrganization(body: OrganizationBody) {
  await _pHttp.post(`/organization`, body);
}

export const getSpecialAccess = async () => {
    const { data } = await _pHttp.get(`operator/all/specialAccess`);
    return data;
  };


  export const getOrganization = async () => {
    const { data } = await _pHttp.get(`organization/all`);
    return data;
  };
  
  export const getOrganizationList = async (params?: {
    page?: number | string;
    search?: string;
    filter?: string | number;
    numberInPage?: number | string;
  }) => {
    const { data } = await _pHttp.get(`organization`, { params });
    return data;
  };

  export const getOrganizationSpecial = async () => {
    const { data } = await _pHttp.get(`organization/all/active`);
    return data;
  };